/*
 * @Author: Enzo
 * @Date: 2021-07-22 10:52:16
 * @LastEditTime: 2021-07-27 11:59:26
 * @LastEditors: Enzo
 * @Description:
 * @FilePath: /waimai_cd_fe_greentech_c/src/components/UserData/AuthRoute.js
 * God is watching you
 */
import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import P from 'prop-types';
import { useUserData } from './index';

const roleType3Path = ['/nomination/:nominationCode', '/recommend/:recommendCode'];

export function AuthRoute(props) {
    const { roleType, mtUid } = useUserData();
    const localRole = localStorage.getItem('greentech_roleType');
    const localUid = localStorage.getItem('greentech_mtUid');
    const role = localRole ? Number(localRole) : Number(roleType);
    const _mtUid = localUid || mtUid;
    const requireLogin = props.requireLogin;

    // 自动识别pathPrefix，仅用于权限判断
    const pathPrefixMatch = props.path.match(/^\/v\d+/);
    const pathPrefix = pathPrefixMatch ? pathPrefixMatch[0] : '';
    const purePath = pathPrefix ? props.path.slice(pathPrefix.length) : props.path;

    // roleType 3
    if (roleType3Path.includes(purePath)) {
        if (role && !props.auth.includes(Number(role))) {
            return <Redirect to="/home" />;
        }
        return <Route {...props} />;
    }
    if (props.auth && !props.auth.includes(Number(role))) {
        return <Redirect to="/home" />;
    }
    if (requireLogin && !_mtUid) {
        return <Redirect to="/home" />;
    }

    return <Route {...props} />;
}

AuthRoute.propTypes = {
    auth: P.arrayOf(P.number),
    requireLogin: P.bool,
};

AuthRoute.defaultProps = {
    auth: undefined,
    requireLogin: true,
};
